module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x1-steel_256.08d3bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x1-steel_256.png
// module id = 0ZBq
// module chunks = 0